import { gql } from '@apollo/client';

export const DELETE_KANBAN_LABEL_SET = gql`
    mutation DeleteKanbanLabelSet($id: String!) {
        deleteKanbanLabelSet(id: $id) {
            id
        }
    }
`;
